import { SearchCategories } from 'components/mediaLibrary/constants';
import { Button, Checkbox, Dropdown, Input } from 'semantic-ui-react';
import styled from 'styled-components';

const EMPTY_SEARCH = '';

const SEARCH_CATEGORIES = [
  SearchCategories.All,
  SearchCategories.Names,
  SearchCategories.Tags,
  SearchCategories.Manuscript,
  SearchCategories.Description,
];

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 1.5rem;
`;

const SearchBox = styled.div`
  flex: 0 1 560px;
  min-width: min(320px, 100%);
`;

interface Props {
  onSearchChange: (searchTerm: string) => void;
  onCategoryChange: (category: SearchCategories) => void;
  onShowArchivedChange: (showArchived: boolean) => void;
  searchCategory: SearchCategories;
  searchTerm: string;
  showArchived: boolean;
}

/** The classic block search: one search term limited to a category, with a "Show archive" toggle beside it. */
export function ClassicBlockSearch({ onSearchChange, onCategoryChange, onShowArchivedChange, searchCategory, searchTerm, showArchived }: Props) {
  return (
    <Row>
      <SearchBox>
        <Input
          fluid
          size="large"
          value={searchTerm}
          placeholder="Search ..."
          aria-label="Search blocks"
          onChange={(e) => onSearchChange(e.target.value)}
          label={
            <Dropdown
              value={searchCategory}
              aria-label="Search in"
              onChange={(_, { value }) => onCategoryChange(value as SearchCategories)}
              options={SEARCH_CATEGORIES.map((category) => ({ key: category, value: category, text: category }))}
            />
          }
          action={
            <Button
              icon="times"
              aria-label="Clear search"
              disabled={!searchTerm || searchTerm === EMPTY_SEARCH}
              onClick={() => onSearchChange(EMPTY_SEARCH)}
            />
          }
        />
      </SearchBox>
      <Checkbox label="Show archive" checked={showArchived} onChange={() => onShowArchivedChange(!showArchived)} toggle />
    </Row>
  );
}
